<form #personalForm="ngForm" class="editForm" novalidate>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-primary">
        <div class="card-header text-uppercase"> {{title}} </div>
        <div class="card-body">
          <!-- <div class="text-center">
            <p class="">
              Applicants who opt for <mark>Diploma in General Drilling (Fee Paying)</mark> or <mark>Certificate Programme in English</mark>  should not select any other programme. For applicants opting for BSc. Degree Programmes, please select programme in order of preference. Do not choose the same programme twice
            </p>
          </div> -->


          <div class="table-responsive">
            <table class="table">
              <thead class="thead-primary">
                <tr>
                  <th>Choice</th>
                  <th>Select Programme</th>
                  <th *ngIf="!isForignStudent()">Fees Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let choice of applicantProgrammeSelection; let i=index">
                  <td>{{choice.Name}}</td>
                  <td>

                    <select name="data-{{i}}" [(ngModel)]="choice.ProgrammeId"
                      (change)="onProgrammeChanged(choice,$event)" class="form-control form-control-sm">
                      <option value="0">Please select your {{choice.Name}} choice</option>
                      <option *ngFor="let item of choice.Programmes;" value="{{item.ProgrammeId}}">
                        {{item.FullName}}
                      </option>
                    </select>
                  </td>
                  <td *ngIf="!isForignStudent()">
                    <select [(ngModel)]="choice.ProgrammeFundingId" name="data2-{{i}}"
                      class="form-control form-control-sm">
                      <option value="">Please Fee Status</option>

                      <option *ngFor="let item of choice.Fundings" value="{{item.FundingId}}">{{item.Name}}</option>
                    </select>
                  </td>
                </tr>



              </tbody>
            </table>
          </div>


        </div>
        <div class="form-footer">
          <div class="form-group text-center">
            <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious()"><i
                class="fa fa-backward"></i> Go Back</button>
            <button class="btn btn-primary waves-effect waves-light m-1" id="next" [disabled]="!isValidChoices()"
              (click)="goToNext(personalForm)">Save &amp; Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>